<template>
  <div>
    <el-dialog
      @open="handleOpen"
      :title="this.text.title"
      :visible.sync="this.dialogStatus"
      width="20%"
      :modal-append-to-body="false"
      :before-close="beforeClose"
      :destroy-on-close="true"
      append-to-body>
      <el-form :model="formData" :rules="rules" ref="codeForm">
        <el-form-item prop="mobile">
          <el-input v-model="formData.mobile" disabled placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input v-model="formData.code" placeholder="请输入验证码">
            <template slot="append">
              <el-button type="text" class="get-register" @click="verificationCode">{{ this.text.codeText }}</el-button>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="handleClose">取消</el-button>
        <el-button size="medium" class="vcodeBtn" type="primary" @click="onSubmit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
/* eslint-disable */
import { mapGetters, mapState, mapActions } from 'vuex'
export default {
  name: "Vertification",
  props: {
    is_verify: {
      type: Boolean,
      default: true
    },
    text: {
      type: Object,
      default: () => {
        return {
          title: "验证手机",
          codeText: "获取验证码",
        }
      }
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dialogBillVisible: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.userInfo,
    })
  },
  watch: {
    dialogVisible(val) {
      this.dialogStatus = val;
    },
    dialogBillVisible(val) {
      this.dialogStatus = val;
    },
  },
  data() {
    return {
      dialogStatus: false,
      formData: {
        mobile: '',
        code: ''
      },
      rules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ]
      }
    }
  },
  methods: {
    beforeClose() {
      this.$emit('dialogChanged', false)
    },
    handleOpen() {
      const { mobile } = this.user
      this.formData.mobile = mobile
    },
    handleClose() {
      this.$emit('dialogChanged', false)
    },

    //验证验证码
    async smsVerify() {
      let data = {
          mobile: this.formData.mobile,
          code: this.formData.code
        }
      if(this.is_verify){
        let args = {
          mobile: this.formData.mobile,
          code: this.formData.code,
        }
        let result = await this.$api.smsVerify(args)
        if(result) {
          this.$emit('onSuccess',data)
        }
      }else{
          this.$emit('onSuccess',data)
      }
    },

    //验证
    onSubmit() {
      this.$refs['codeForm'].validate(valid => {
        if (valid) {
          this.smsVerify()
        } else {
          this.$message.error('验证失败，请重新验证')
          return false
        }
      })
      this.$refs['codeForm'].resetFields();
    },
     //获取验证码
    async verificationCode(){
      let verCode  = await this.$api.smsSend({
        mobile: this.formData.mobile
      })
      this.countDown(60)
    },
    // 倒计时方法
    countDown (time) {
      if (time === 0) {
        this.text.codeText = "获取验证码"
        return
      } else {
        this.text.codeText = '重新发送(' + time + ')'
        time--
      }
      setTimeout(()=> {
        this.countDown(time)
      }, 1000)
    },
    //实际短信验证请求
    async formCodeSubmit() {
      let data = {
          mobile: this.formData.mobile,
          code: this.formData.code
        }
      if(this.is_verify){
        let userInfo = await this.$api.verifyCode({
          mobile: this.formData.mobile,
          code: this.formData.code
        })
        if (userInfo) {
          this.$emit('onSuccess',data)
        }
      } else {
        this.$emit('onSuccess',data)
      }
    },
  }
}
</script>
<style scoped lang="stylus">
.get-register
  width: 100px
.vcodeBtn
  margin-left: 10px
.el-button.vcodeBtn.el-button--primary.el-button--medium
  margin-left: 10px
</style>